import { z } from "zod";

export const communityActivityFeedReferenceTypeEnum = z.enum([
  "intention",
  "prompt_response",
  "prayer_completion_summary",
  "icebreaker_response",
]);

export type CommunityActivityFeedReferenceType = z.TypeOf<
  typeof communityActivityFeedReferenceTypeEnum
>;
